
import {Component, OnInit} from '@angular/core';
import {CallBackEndService} from '../call-back-end.service';
import {IbRequest} from '../ib-request';
import {IbResponse} from '../ib-response';
import { Jsonp } from '@angular/http';
import { MyDatePickerModule ,IMyInputFocusBlur} from 'mydatepicker';
import {IMyDpOptions, IMyDateModel, IMyOptions} from 'mydatepicker';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment';
import {DatePipe} from "@angular/common";
declare var getHexAscii: any;


@Component({
  selector: 'app-standing-instruction',
  templateUrl: './standing-instruction.component.html',
  styleUrls: ['./standing-instruction.component.css'],
   providers: [DatePipe]
})
export class StandingInstructionComponent implements OnInit {
 
  isShow: string = 'hide';
  siAmount: string = '';
  payeeName: string = '';
  payeeAccNo: string = '';
  IFSCcode: string = '';
  branch: string = '';
  freqInDays: any = '';
  startDate: any;
  accNo: string = '';
   regNum =  /^(\d*\.)?\d+$/;
  isError: string = '';
  isLoad: boolean = true;
  disabled: boolean = true;
 endDate:any;
 errFlagAccNo='no';
 errFlagPayeeAccNo='no';
 errFlagSIAmount='no';
 errFlagFreq='no';
 errFlagFreqInDays='no';
 errFlagStartDate='no';
 errFlagEndDate='no';
  //otpDetails1: any;
  user1 : string ='';
  otp1 : string ='';
  confirmAdhaarNo: string = '';
 messageForAccRequired:string='';
 selectedDaysArray=[];
messageForSIRequired='';
msgForAmountNumber='';
msgForPayeeAccRequired='';
msgforPayeeAccNoSplChar='';
msgforPayeeAccnNonly='';
msgForStartDateRequired='';
msgForEndDateRequired='';
msgforaccerr='';
errorFlagOtp="no";
msgForDateVal="";
hidSchPay:string;
accerr='';
  day:number;
  accounts: any = [];
   regsplchar=/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
    regchar='/^[a-zA-Z]+$/';
    regexpspace=/\s+/;
    regZeroOnly='^[0][0]*[0]$';
    regexcap =/^.*?[A-Z]/;
  msgforPayeeAccNoSpace:string='';
  msgforPayeeAccNoLen:string='';
   mytime:Date = new Date();
    currentYear:any= this.mytime.getUTCFullYear();
    currentDate:any= this.mytime.getUTCDate()+1;
    currentMonth:any= this.mytime.getUTCMonth() + 1; 
     currentMonth1:any= this.mytime.getUTCMonth() + 7; 
    myDatePickerOptions: IMyDpOptions = {
        inline: false,
        dateFormat: 'dd-mmm-yyyy',
        editableDateField:false,
        openSelectorTopOfInput:true,
       disableUntil:{year: this.currentYear, month: this.currentMonth, day: this.currentDate+3}
    };
       myDatePickerOptions1: IMyDpOptions = {
        inline: false,
        dateFormat: 'dd-mmm-yyyy',
        editableDateField:false,
        openSelectorTopOfInput:true,
        disableUntil:{year: this.currentYear, month: this.currentMonth, day: this.currentDate+5},
    };
   freqType:any;
type:string="D";
msgForFreqDaysRequired="";
msgForFreqTypeRequired:string="";
msgForFreqDaysTypeRequired:string="";
msgForOtpRequired:string="";
AccNoDisp="";
SIAmountDisp="";
payeeAccNoDisp="";
payeeNameDisp="";
IFSCcodeDisp="";
branchDisp="";
freqTypeDisp="";
freqInDaysDisp="";
startDateDisp="";
endDateDisp="";
Otp="";
msgFordateDiff="";
errorDescription="";
noOfPaymnts:string;
msgForNoPayRequired:string="";
msgForNoPayNumber:string="";
msgForNoPaySpace:string="";
SuccessMessage="";
 isDisabled : boolean = false;
isDisabled2 : boolean = false;
isError1: boolean = false;
msgForAmountSpace:string="";
showText="no";
  public rowsOnPage = 5;
  public sortBy = 'Srno';
  public sortOrder = 'asc';
   public filterQuery = '';
   errFlagNoOfPaymnt='';

   regNumsOnly =/^\d+$/;

data: Array<{Srno: number, date:string}> =[];
  accerr1: string;
  constructor(private webService: CallBackEndService,private spinnerService: Ng4LoadingSpinnerService,private datePipe: DatePipe) {
this.accounts= JSON.parse(sessionStorage.getItem('scoAccounts'));
console.log('linkedAccounts----'+this.accounts);
  this.type='days';

  }

   ngOnInit(): void {
  }
changeIt(){
  console.log("on change");
       let  Max:any=0;

let Min:any=0;
let i:any=0;
let j:any=0;
let freqInDays1 =this.freqInDays;
 this.selectedDaysArray.splice(0);
   console.log("console.log(freqInDays.options[1]);"+this.freqType);
   if(this.freqType==='D'){
     console.log("days selected");
     Max = 30;
     Min = 5;
    //this.selectedDaysArray=[5,6,7,8,9,10,11,12,13,14,15,];
   }else if(this.freqType==='M'){
      Max = 6;
           Min = 1;
    // this.selectedDaysArray=[1,2,3,4];
   }


    for(Min; Min<=Max; Min++)
         {
           this.selectedDaysArray[i]=Min;
              i++;
         }
}

validateAcc()
{
  //this method is to validate debit account number
//   console.log("valiate");
//  const request: IbRequest = new IbRequest();
//     let response: IbResponse = null;
//     const accDetails={"acctNo":this.accNo,
//     "type":"D"
//   };
//     request.param6=accDetails;
//     request.param2=this.accNo;
//     request.param3="D";
//     request.param1 = getHexAscii("", this.accNo+"D");
//       this.webService.getResponse(request, 'isValidSIAccountNo').subscribe((data: IbResponse) => {
//       this.isLoad = false;
//       this.disabled = true;
//       if (data.status === 'S101') {
//         alert('Malicious Request Detected');
//         this.isLoad = false;
//       } if (data.status === 'S200') {
//         response=data;
//       }
//     });
    

}

openNextPage(){
console.log(this.errFlagAccNo);
 if (this.accNo === '' ||this.accNo===' '||this.accNo===undefined||this.accNo===null) 
    {
     this.messageForAccRequired="no";
   }else  if (this.siAmount === '' ||this.siAmount===' '||this.siAmount===undefined||this.siAmount===null) 
    {
     this.messageForSIRequired="no";
    }else if(!this.siAmount.match(this.regNum))
    {
      this.msgForAmountNumber="no";
    }else if(this.siAmount.match(this.regexpspace))
    {
      this.msgForAmountSpace="no";
    }else if (this.payeeAccNo === '' ||this.payeeAccNo===' '||this.payeeAccNo===undefined||this.payeeAccNo===null) 
    {
      this.msgForPayeeAccRequired="no";
    }else if(this.payeeAccNo.match(this.regexpspace))
    {
      this.msgforPayeeAccNoSpace= 'no';
    }else if(this.payeeAccNo.match(this.regsplchar))
    {
      this.msgforPayeeAccNoSplChar= 'no';
    }else if(!this.payeeAccNo.match(this.regNum))
    {
      this.msgforPayeeAccnNonly = 'no';
    }else if(this.payeeAccNo.length>15||this.payeeAccNo.length<15)
    {
      this.msgforPayeeAccNoLen = 'no';
    }else if(this.freqType === '' ||this.freqType===' '||this.freqType===undefined||this.freqType===null) 
    {
      this.msgForFreqDaysTypeRequired='no';
    }else if(this.freqInDays === '' ||this.freqInDays===' '||this.freqInDays===undefined||this.freqInDays===null)
    {
          this.msgForFreqDaysRequired="no";
     } else if (this.noOfPaymnts === '' ||this.noOfPaymnts===' '||this.noOfPaymnts===undefined||this.noOfPaymnts===null) 
    {
      this.msgForNoPayRequired="no";
   }else  if(this.siAmount.match(this.regexpspace))
    {
      this.msgForNoPaySpace="no";
    }else if(!this.noOfPaymnts.match(this.regNum))
    {
      this.msgForNoPayNumber="no";
    }else if(this.startDate.date===null||this.startDate.date===undefined||this.startDate.date===" ")
     {
         this.msgForStartDateRequired="no";
     }else if(this.payeeName==='' || this.payeeName==undefined || this.payeeName==null
    || this.IFSCcode==='' || this.IFSCcode==undefined || this.IFSCcode==null
    || this.branch==='' || this.branch==undefined || this.branch==null){

         this.accerr='Error :'+this.accerr1;
         console.log('in err : '+this.IFSCcodeDisp+this.payeeNameDisp+this.branchDisp);
     }
  else{

    // console.log('calinng gen otp : ');
  let startdate= (new Date(this.startDate.date.year , this.startDate.date.month, this.startDate.date.day));
      //let enddate=(new Date(this.endDate.date.year , this.endDate.date.month, this.endDate.date.day));
//       let days=this.daysBetween( startdate, enddate );
//       console.log("days aree "+days);
//        let d1 = Date.parse(startdate[0] + "" + startdate[1] + "" + startdate[2]);
//       let d2 = Date.parse(enddate[0] + "" + enddate[1] + "" + enddate[2]);
//  console.log("date---"+d1+"**(***"+d2);
  // if(days<0) {
   
  //    this.msgForDateVal='no';
  //    console.log("ingreat");

  // }else if(days<180)
       //{
         console.log("in sub");
          this.spinnerService.show();
     this.isDisabled = true ;
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
   let  userName =sessionStorage.getItem('storedUserName');
    request.param1 = getHexAscii("",userName);
    request.param2 = userName;
    let daysBetween ;


     this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
      this.isLoad = false;
      this.disabled = true;
       this.spinnerService.hide();
      if (data.status === 'S101') {
        alert('Malicious Request Detected');
        this.isLoad = false;
      } if (data.status === 'S200') {
       // this.getOtpResp = data;
       // console.log('Otp :' + this.getOtpResp.param1);
        this.isShow = 'show';
        this.AccNoDisp=this.accNo;
        this.SIAmountDisp=this.siAmount;
        this.payeeAccNoDisp=this.payeeAccNo;
        this.payeeNameDisp=this.payeeName;
        this.IFSCcodeDisp=this.IFSCcode;
        this.branchDisp=this.branch;
        this.insertTable(2, 2, 2);
        this.showText='yes';
        if(this.freqType==="D"){
          this.freqTypeDisp="Days";
        }else  if(this.freqType==="M"){
           this.freqTypeDisp="Months"; 
        }
      
        this.freqInDaysDisp=this.freqInDays;
        this.startDateDisp=this.startDate.formatted;
       // this.endDateDisp=this.endDate.formatted;

      }
      else{

        this.isDisabled = false ;
      }
    });
    
  
  // }
  // else
  // {
  //      this.msgFordateDiff="no";
  //       console.log("in sub11111111111111");
  // }
  
  }
 
}

 
submitSI()
{
  //  if (this.Otp === '' ||this.Otp===' '||this.Otp===undefined||this.Otp===null) 
  //   {
  //    this.msgForOtpRequired='no';
  //    this.errorFlagOtp='no';
  //   }else{
    if(this.ValidateOtp()){

  this.spinnerService.show();
  this.isDisabled2=true;
  console.log("aaaa");
   const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
     request. param2= this.freqInDays;
     let date1=JSON.stringify(this.startDate);
     console.log("date1--"+this.startDate);
     let userName=sessionStorage.getItem("storedUserName");
     let otp=getHexAscii("",this.Otp);
     let startDate1=this.startDate.date.day +"-"+this.getMonthName(this.startDate.date.month)+"-"+this.startDate.date.year;
    //   let date2=JSON.stringify(this.endDate);
    //  let endDate1=this.endDate.date.day +"-"+this.getMonthName(this.endDate.date.month)+"-"+this.endDate.date.year;
     request.param3 = startDate1;
    /// request.param4 = endDate1;
    request.param4=this.noOfPaymnts;
     request.param5 = this.siAmount;
    // let accDetails={"crAcctNo" :this.accNo, "drAcctNo" :this.payeeAccNo,"siFreq" :this.freqType,"userName":userName,"otp":otp,"payeename":this.payeeName};
    let accDetails={"crAcctNo" :this.payeeAccNo ,"drAcctNo" :this.accNo ,"siFreq" :this.freqType,"userName":userName,"otp":otp,"payeename":this.payeeName};

    request.param6 = accDetails;
    request.param1 = getHexAscii("", request.param2+request.param3+request.param4+ request.param5+userName+otp);


      this.webService.getResponse(request, 'saveSTIDetails').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
      this.isLoad = false;
      this.disabled = true;
     
      if (data.status === 'S101') {
        alert('Malicious Request Detected');
        this.isLoad = false;
      } if (data.status === 'S200') {
         this.SuccessMessage=data.param1;
        this.isShow = 'success';
      }else{
        this.isError1=true;
        this.errorDescription=data.param1;
        this.isDisabled2=false;
      }
    });
  }
}
getMonthName(month) 
{ 
return ["Jan","Feb","Mar","Apr","May","June","Jul","Aug","Sep", "Oct","Nov","Dec"][parseInt(month)-1]
}
validateAccNo()
{
   if (this.accNo === '' ||this.accNo===' '||this.accNo===undefined||this.accNo===null) 
    {
    
      this.messageForAccRequired="no";
      this.errFlagAccNo="no";
   }else{
      this.errFlagAccNo="yes";
   }

} 
clearAccNo()
{
 this.messageForAccRequired=" ";

}
validateSI()
{
   if (this.siAmount === '' ||this.siAmount===' '||this.siAmount===undefined||this.siAmount===null) 
    {
    
      this.messageForSIRequired="no";
      this.errFlagSIAmount='no';

   }else if(!this.siAmount.match(this.regNum))
    {
      this.msgForAmountNumber="no";
      this.errFlagSIAmount='no';
     }else if(this.siAmount.match(this.regexpspace))
    {
      this.msgForAmountSpace="no";
      this.errFlagSIAmount='no';
     }
     else
     {
       this.errFlagSIAmount='yes';
     }

}
clearSI(){

  this.messageForSIRequired="";
  this.msgForAmountNumber="";
}
ValidatepayeeAccNo()
{
 if (this.payeeAccNo === '' ||this.payeeAccNo===' '||this.payeeAccNo===undefined||this.payeeAccNo===null) 
    {
      this.msgForPayeeAccRequired="no";
      this.errFlagPayeeAccNo='no';

   }else if(this.payeeAccNo.match(this.regexpspace))
    {
      this.msgforPayeeAccNoSpace= 'no';
      this.errFlagPayeeAccNo='no';
      
     }else if(this.payeeAccNo.match(this.regsplchar))
    {
      this.msgforPayeeAccNoSplChar= 'no';
      this.errFlagPayeeAccNo='no';
      
     }else if(!this.payeeAccNo.match(this.regNum))
    {
      this.msgforPayeeAccnNonly = 'no';
      this.errFlagPayeeAccNo='no';
      
     }else if(this.payeeAccNo.length>15||this.payeeAccNo.length<15)
    {
      this.msgforPayeeAccNoLen = 'no';
      this.errFlagPayeeAccNo='no';
       
     }
    else{
      this.errFlagPayeeAccNo='yes'
        this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      const accDetails={"acctNo":this.payeeAccNo,
    "type":"C"
  };
    request.param6=accDetails;
    request.param2=this.payeeAccNo;
    request.param3="C";
    request.param1 = getHexAscii("", this.payeeAccNo+"C");
      this.webService.getResponse(request, 'isValidSIAccountNo').subscribe((data: IbResponse) => {
      this.isLoad = false;
      this.disabled = true;
      this.spinnerService.hide();
      if (data.status === 'S101') {
        alert('Malicious Request Detected');
        this.isLoad = false;
      } if (data.status === 'S200') {
        this.errFlagPayeeAccNo='yes';
        this.branch  =data.param1;
        this.payeeName=data.param2;
        this.IFSCcode=data.param3;
        //this.IFSCcodeDisp=this.IFSCcode;
      }
      else{
        this.branch  ='';
        this.payeeName='';
        this.IFSCcode='';

        this.accerr1=data.param1;
        this.accerr=data.param1;
        this.msgforaccerr='no';

      }
    });
  }

}

clearPayeeAcc()
{
 this.msgForPayeeAccRequired="";
 this.msgforPayeeAccNoSpace= '';
   this.msgforPayeeAccNoSplChar= '';
   this.msgforPayeeAccnNonly = '';
   this.msgforPayeeAccNoLen = '';
   this.accerr="";
}

ValidateFreqType()
{
   if (this.freqType === '' ||this.freqType===' '||this.freqType===undefined||this.freqType===null) 
    {
        this.msgForFreqTypeRequired="no";
        this.errFlagFreq='no';
    }else{
      this.msgForFreqDaysTypeRequired="";
      this.errFlagFreq='yes';
    }
   
}
clearFreqType()
{
this.msgForFreqTypeRequired=" ";
}

ValidateFreqDays()
{
   if (this.freqType === '' ||this.freqType===' '||this.freqType===undefined||this.freqType===null) 
    {
      this.msgForFreqDaysTypeRequired='no';
      this.errFlagFreqInDays='no';
    }else if(this.freqInDays === '' ||this.freqInDays===' '||this.freqInDays===undefined||this.freqInDays===null)
    {
          this.msgForFreqDaysRequired="no";
          this.errFlagFreqInDays='no';
    }else{
      this.errFlagFreqInDays='yes';
    }
 
}
clearFreqDays()
{
 this.msgForFreqDaysRequired=" ";
}
  onDateChanged(event: IMyDateModel) {
      //console.log("event date---"+JSON.stringify(event.formatted));
     let date1=JSON.stringify(event.formatted);
     this.msgFordateDiff="";
     this.msgForDateVal="";
    //console.log("date1.length----"+date1.length+"date2"+date2+"date1"+date1+"@@@@"+date3);
     if(event==null){
       this.msgForStartDateRequired = 'no';
       this.errFlagStartDate='no';
     }
     else if (date1==='""'||date1==='" "'||date1==='"  "' ||date1===undefined||date1===null) 
    {
     this.msgForStartDateRequired = 'no';
     this.errFlagStartDate='no';
     
   }else{
      
        this.msgForStartDateRequired='';
        this.errFlagStartDate='yes';
   }
     
    }
    onEndDateChanged(event: IMyDateModel) {
      //console.log("event date---"+JSON.stringify(event.formatted));
     let date1=JSON.stringify(event.formatted);
    //console.log("date1.length----"+date1.length+"date2"+date2+"date1"+date1+"@@@@"+date3);
      this.msgFordateDiff="";
     this.msgForDateVal=""; 
    
    if(event==null){
       this.msgForEndDateRequired = 'no';
       this.errFlagEndDate='no';
     }
     else if (date1==='""'||this.endDate==='" "'||date1==='"  "' ||date1===undefined||date1===null) 
    {
     this.msgForEndDateRequired = 'no';
      this.errFlagEndDate='no';
     
   }else{
      
        this.msgForEndDateRequired='';

         this.errFlagEndDate='yes';
   }
     
    }

openPage1()
{
 
  this.isShow="hide";
  this.isDisabled=false;
  this.data=[]; 
}
ValidateOtp()
{
    if (this.Otp === '' ||this.Otp===' '||this.Otp===undefined||this.Otp===null) 
    {
     this.msgForOtpRequired='no';
     this.errorFlagOtp='no';
    }else if(!this.Otp.match(this.regNumsOnly)){  
      this.msgForOtpRequired='nums';
      return false;
    }
    else{
      this.errorFlagOtp='yes';
      return true;
    }
}
clearOtp()
{
  this.msgForOtpRequired='';
}
daysBetween( date1, date2 ) {
    //Get 1 day in milliseconds
    let  one_day=1000*60*60*24;

    // Convert both dates to milliseconds
    let date1_ms = date1.getTime();
    let date2_ms = date2.getTime();

    // Calculate the difference in milliseconds
    let difference_ms = date2_ms - date1_ms;
    //take out milliseconds
    difference_ms = difference_ms/1000;
    let seconds = Math.floor(difference_ms % 60);
    difference_ms = difference_ms/60;
    let minutes = Math.floor(difference_ms % 60);
    difference_ms = difference_ms/60;
    let hours = Math.floor(difference_ms % 24);
    let days = Math.floor(difference_ms/24);
    console.log("days isss "+days);
    //return days + ' days, ' + hours + ' hours, ' + minutes + ' minutes, and ' + seconds + ' seconds';
    return days;
  }
  validateNoOfPayment()
  {
    if (this.noOfPaymnts === '' ||this.noOfPaymnts===' '||this.noOfPaymnts===undefined||this.noOfPaymnts===null) 
    {
    
      this.msgForNoPayRequired="no";
      this.errFlagNoOfPaymnt='no';

   }else  if(this.siAmount.match(this.regexpspace))
    {
      this.msgForNoPaySpace="no";
      this.errFlagNoOfPaymnt='no';
     }else if(!this.noOfPaymnts.match(this.regNum))
    {
      this.msgForNoPayNumber="no";
      this.errFlagNoOfPaymnt='no';
     }else
     {
       this.errFlagNoOfPaymnt='yes';
     }
  }
  clearNoPaymnts()
  {
  this.msgForNoPayRequired="";
  this.msgForNoPayNumber="";
  this.msgForNoPaySpace="";
  }

  numberOfDays(year, month) {
        let d = new Date(year, month, 0);
         return d.getDate();
  }
  getDaysInMonth(m, y) {
        return /8|3|5|10/.test(--m+"")?30:m===1?(!(y%4)&&y%100)||!(y%400)?29:28:31;
    }
 dateDifference(startDate,endDate,retType){
		try{
		retType=retType.toLowerCase();		
		var diff = Date.UTC(endDate.getFullYear(),endDate.getMonth(),endDate.getDate(),0,0,0)- Date.UTC(startDate.getFullYear(),startDate.getMonth(),startDate.getDate(),0,0,0);
		
		var minsleft= diff/1000/60;		
		var hrsleft = minsleft/60;		
		var daysleft = hrsleft/24;
		
		switch(retType){
			case "sec":
					return diff;
			case "mins":
					return minsleft;		
			case "hrs":
					return hrsleft;
			case "days":
					return daysleft; 
			case "months":
					return this.returnMonths(startDate.date,endDate); 
			default:
					return 0;
		}
		}catch(e){
			console.log("Error !!!");
		}
  }
   
	returnMonths(date1, date2) {
		var y1 = date1.getFullYear(), m1 = date1.getMonth(), d1 = date1.getDate(),
		y2 = date2.getFullYear(), m2 = date2.getMonth(), d2 = date2.getDate();
		if (d1 < d2) {
		m1--;
		d1 += this.DaysInMonth(y2, m2);
		}
		if (m1 < m2) {
		y1--;
		m1 += 12;
		}
		return ((y1 - y2)* 12 ) + ( m1 - m2);
	} 
	DaysInMonth(Y, M) {
   let newDt= new Date(Y, M, 1, 12);
        	newDt.setDate(0);
			return newDt.getDate();
		
	} 
insertTable(num_rows,num_cols,width)
{

           var theader = '<table border="1"  class="row-border tableHeader" style="border-collapse: collapse;font-size:15px" bordercolor="#faa22f"  id="example" width="69%" datatable 	><thead>';
           var tbody = "";
                    
            for(var j = 0; j < num_cols; j++)
             {
                //theader += "<th>header col "+ (j+1) +" </th>";
                if (j===0)
                 {
                   theader += "<th  class='headtd backhead'><font color='#CC0000'>Instruction Number </font></th>";
                 }else
                {
                     theader += "<th  class='headtd backhead'><font color='#CC0000'>Scheduled Date </font></th></thead>";
                }
             }
          var dateobj= new Date() ;
          let month = dateobj.getMonth()+""; 
          var day = dateobj.getDate();
          var year = dateobj.getFullYear();
          var freqType     = this.freqType;
          var freqInDays   = this.freqInDays;
          var noOfPayments = this.noOfPaymnts;
          //alert("freqType--"+freqType);
          //alert("freqInDays--"+freqInDays);
          //alert("noOfPayments--"+noOfPayments); 		
          let datesplit1=(this.startDate.formatted).split("-");
          let date = datesplit1[0];
          month =datesplit1[1]+"";
          //alert(datesplit1)
          let  monArr=new Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec");
           for(var i=0;i<12;i++){
                 if(monArr[i]===month){
                  month = i+"";
                  break;
             }
           }
          
                year = datesplit1[2];
                var yearInDays=365*24*60*60*1000;
            var startDate= new Date(year,parseInt(month),date);
            
           // alert("St--"+startDate+"mo--"+month);
						var startTime = startDate.getTime();
						var dateoneYearAfter=new Date(startTime+yearInDays);
						var everyday =null;
						//alert("startDate--"+startDate);
						//alert("startTime--"+startTime);
						//alert("dateoneYearAfter--"+dateoneYearAfter); 
						var daysAdded = null;
            var totdaymth =  null;
           // alert(freqType);
						if(freqType === "D"){
							daysAdded = eval(freqInDays)*eval(noOfPayments);
              everyday = eval(daysAdded)/eval(noOfPayments);
              //alert("daysAdded1--"+daysAdded);
						}else{
							daysAdded = eval(freqInDays)*30*eval(noOfPayments);
              everyday = eval(daysAdded)/eval(noOfPayments);
             // alert("daysAdded2--"+daysAdded);
            }
             
						// alert("everyday--"+everyday);
						// alert("startDate--"+startDate);
						// alert("startTime--"+startTime); 
						//alert("dateoneYearAfter--"+dateoneYearAfter);
						var stDt=new Date(startDate);
						var dday = stDt.getDate();
						//var dt=parseInt(stDt.getDate()+eval(everyday));		
					    //stDt.setDate(dt);
					    //alert("stDt--"+stDt);
						/*for(var i=0;i<noOfPayments;i++){
						   dt=parseInt(stDt.getDate()+eval(everyday));		
					       stDt.setDate(dt);
					       alert("stDt--"+i+"--"+stDt);
								
							}*/
						
						var daysAddedInTime = eval(daysAdded)*24*60*60*1000;
					//alert("daysAddedInTime--"+daysAddedInTime);
                         let lastPayDate = new Date(daysAddedInTime+startTime);
						//alert("lastPayDate--"+lastPayDate);
                       if(freqType ==='D')
						{
                           totdaymth = this.dateDifference(startDate,lastPayDate,'days');
						}else
						{
							totdaymth = this.dateDifference(startDate,lastPayDate,'months');
						}
					
					//alert("noOfPayments--"+noOfPayments);	
					/*tbody += "<tr>";
					tbody +="<td colspan ='2' width='80%' class='headtd'><font size ='3' color='#FF0000'>Select Payment Option</font></td>";
				    tbody +="</tr>";*/
				   everyday = dday ;
					var k = 1;
					for(var i = 0; i < parseInt(noOfPayments); i++)
					{
		
						tbody += "<tr>";
						for(var j = 0; j < num_cols; j++)
						{
						    //alert('came'+j); 
							if (j===0)
							{
							    
								tbody += "<td width='35%' class='datatd' style='font-size:12px;text-align:center;background-color:white'>";
								tbody += k;
								tbody += "</td>"
								
								k = k+1;
							}else if (j===1)
							{
								
								//var dateobj= new Date() 
								
								 month = stDt.getMonth()+"" ;
								 day = stDt.getDate();
								 year = stDt.getFullYear();
                              let monArr=new Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec");
								 for(var l=0;l<12;l++){
									if(parseInt(month)==l){
                                         month = monArr[l];
										break;
									}
								}
								//alert("month--"+month)
								var combineDatestr = day + "-" + month + "-" + year;
						//	alert(combineDatestr+"/////////////////////////////////");
								tbody += "<td width='35%'  class='datatd' style='font-size:12px;text-align:center;background-color:white'>";
								tbody += combineDatestr;
                tbody += "</td>"
                let sr=k-1;
                               this.data.push({"Srno":sr,"date":combineDatestr});
								var m = moment(stDt);
								if(freqType === "D")
								{ 
								   //dt=parseInt(stDt.getDate()+eval(everyday));	
					               //stDt.setDate(dt);
					               
					               m.add('days', freqInDays);
						           stDt = m.toDate();
						          
								}else
								{
								    //dt=parseInt(stDt.getDate()+eval(everyday));	
					               //stDt.setMonth(stDt.getMonth() + eval(freqInDays));
					               
					                var month1 = stDt.getMonth() +1
									var day1 = stDt.getDate()
									var year1 = stDt.getFullYear()
									var dayofmth = this.getDaysInMonth(month1,year1);
									
                                    var test = everyday + dayofmth;
                                   
									if (freqInDays == 1)
									{
										if (dday <= dayofmth)
							            {
							               m.add('months', eval(freqInDays));
						                   stDt = m.toDate();
						                 }else
						                 {
						                   //m.add('months', eval(freqInDays));
						                   m.add('days', dday);
						                   stDt = m.toDate();
						                 }
						            }else 
									{
									    
									    if (dday <= dayofmth)
							            {
							             //  alert('--1--'+dayofmth+'--dday--'+dday);
							               m.add('months', eval(freqInDays));
						                   
						                   
							               stDt = m.toDate();
						                }else
						                {
						               //  alert('--2--'+dayofmth+'--dday--'+dday);
						                   //m.add('months', eval(freqInDays));
						                   //eval(dday-dayofmth)
						                   //alert('--2--'+dayofmth+'-test-'+dday);
						                   //m.add('days', everyday);
						                   //m.add('months', eval(freqInDays));
						                   //stDt = m.toDate();
						                   m.add('days', dday*eval(freqInDays)-1);
						                     stDt = m.toDate();
						                   /*if (dday > dayofmth)
							               {
							                 alert('--1.2--'+dayofmth+'--dday--'+dday);
							                 //m.add('days', 1);
							                 m.add('months', eval(freqInDays));
							                 var month2 = stDt.getMonth() 
							       			 var day2 = dday
											 var year2 = stDt.getFullYear()
							                 var startDate2=new Date(year2,month2,day2);
											 var stDt=new Date(startDate2);
							               }else
							               {
							                 m.add('days', dday*eval(freqInDays)-1);
						                     stDt = m.toDate();
						                   }*/
					                       
						                   //alert('--3--'+stDt);
						                   //m.add(eval(dday-dayofmth), 'days');
						                   //stDt.setDate(eval(dday-dayofmth));
						                   
						                   //m.add('days', 0);
						                   
						                   //stDt = m.toDate();
						                   //stDt.setDate(eval(dday-dayofmth));
						                   //alert('--3.1--'+stDt);
						                   
						                }
									
									}
								}
							}
							
						}
						tbody += "</tr>";
          }
          



          var tfooter = "</tbody></table>";
				
          // document.getElementById('#SITable').innerHTML = theader + tbody + tfooter;
          console.log(tbody);
          
        //    setTimeout(function(){ 
           
        //     (document.querySelector('#wrappertext')as HTMLElement).innerHTML = 'The following is a tentative schedule of the feature dated transation';
        //     (document.querySelector('#SITable') as HTMLElement).innerHTML =  theader+tbody+tfooter ; }, 1000);
				}
				 
        allValidation()
        {
      
        }

        }


          




// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/standing-instruction/standing-instruction.component.ts